<div class="basicrow tabtopb f-black roboto-r f-reg">
    <div class="p-3 basicr-line f-big">
        Plan Actual
    </div>
    <div class="basicrow m-top-i">
        <div class="left">
            <div class="userinfo full nomtops">
                <div class="basicrow m-bott">
                    <div class="basicrow f-bmed roboto-b m-bott">
                        Detalle del Plan
                    </div>
                    <div class="autorow roboto-r pull-right">
                        {{this.plan}}
                    </div>
                </div>
                <div class="basicrow m-top-ii">
                    <div class="basicrow f-reg roboto-b m-bott">
                        Descripci&oacute;n del Plan:
                    </div>
                    <div class="descripcion-plan" [innerHtml]="this.soc_des"></div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="caja1-right">
                <div class="basicrow m-top text-center">
                    <div class="servs-monthly planchg">
                        <div class="basicrow">
                            <span class="roboto-b">
                                Fecha de Activaci&oacute;n
                            </span><br />
                            <span class="f-black f-big roboto-b">
                                {{this.act_date}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="caja2-right">
                <div class="basicrow m-top text-center">
                    <div class="servs-monthly planchg">
                        <div class="basicrow l-pline">
                            <span class="roboto-b">
                                Renta Mensual
                            </span><br />
                            <span class="f-red f-big roboto-b">
                                {{this.actualPrice|currency}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="p-3  basicr-line f-big m-top-i">
        Planes Sugeridos
    </div>
</div>
